import { OwnerState } from "../redux/ownerSlice";
import { StoreState } from "../redux/storeSlice";

import { store } from "../redux/store";
import { AdminState } from "../redux/adminSlice";

// تحقق إذا الـ owner مسجل دخول (يوجد accessToken)
export const isOwnerLoggedIn = (): boolean => {
  const state: { owner: OwnerState } = store.getState();
  return !!state.owner.accessToken;
};

// احصل على accessToken الخاص بالـ owner
export const getOwnerAccessToken = (): string => {
  const state: { owner: OwnerState } = store.getState();
  return state.owner.accessToken;
};

// احصل على refreshToken الخاص بالـ owner
export const getOwnerRefreshToken = (): string => {
  const state: { owner: OwnerState } = store.getState();
  return state.owner.refreshToken;
};

// احصل على accessToken الخاص بالـ owner
export const getStoreAccessToken = (): string => {
  const state: { store: StoreState } = store.getState();
  return state.store.accessToken;
};

export const getStoreId = (): number => {
  const state: { store: StoreState } = store.getState();
  return state.store.store.id;
};

export const getAdminAccessToken = (): string => {
  const state: { admin: AdminState } = store.getState();
  return state.admin.accessToken;
};

export const getdeviceId = (): string => {
  const deviceId = localStorage.getItem("uuid");
  return deviceId || "";
};
